// One-off employee earnings (bonus / commission). These are TAXABLE earnings for
// a genuine EMPLOYEE — added to gross + PAYE and shown as their own payslip line
// — as opposed to the non-employee commission rail (contractor withholding).
import axios from 'axios';
import { apiConfig } from '@/config/api.config';
import { attachCookieAuth } from '@/lib/session';

const http = axios.create({ baseURL: apiConfig.baseURL, timeout: 20000, withCredentials: true });
http.interceptors.request.use(attachCookieAuth);

export const oneOffEarningsApi = {
  async stage(body: {
    employee_id: string;
    kind: 'bonus' | 'commission';
    amount: string;
    currency?: string;
    period_month: string; // YYYY-MM
    reference?: string;
  }): Promise<{ staged: boolean }> {
    const { data } = await http.post('/api/v1/payroll/adjustments', body);
    return data;
  },
};
